export default __webpack_public_path__ + "static/media/Cuotitashada.510f0e71.png";